'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherArrowRight } from '@subframe/core';
import type { ReactNode } from 'react';
import { Button } from '@/shared/components/ui';
interface WizardFooterProps {
  voltarLabel: string;
  onVoltar: () => void;
  avancarLabel: string;
  onAvancar: () => void;
  avancarDisabled?: boolean;
  avancarLoading?: boolean;
  /** Conteúdo à esquerda do CTA — resumo da seleção, atalho "Pular". */
  aoLadoDoAvancar?: ReactNode;
}
export const WizardFooter = t0 => {
  const $ = _c(15);
  const {
    voltarLabel,
    onVoltar,
    avancarLabel,
    onAvancar,
    avancarDisabled: t1,
    avancarLoading: t2,
    aoLadoDoAvancar
  } = t0;
  const avancarDisabled = t1 === undefined ? false : t1;
  const avancarLoading = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== onVoltar || $[1] !== voltarLabel) {
    t3 = <Button variant="neutral-secondary" size="medium" onClick={onVoltar}>{voltarLabel}</Button>;
    $[0] = onVoltar;
    $[1] = voltarLabel;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <FeatherArrowRight />;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== avancarDisabled || $[5] !== avancarLabel || $[6] !== avancarLoading || $[7] !== onAvancar) {
    t5 = <Button size="medium" iconRight={t4} disabled={avancarDisabled} loading={avancarLoading} onClick={onAvancar}>{avancarLabel}</Button>;
    $[4] = avancarDisabled;
    $[5] = avancarLabel;
    $[6] = avancarLoading;
    $[7] = onAvancar;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== aoLadoDoAvancar || $[10] !== t5) {
    t6 = <div className="flex flex-wrap items-center gap-4">{aoLadoDoAvancar}{t5}</div>;
    $[9] = aoLadoDoAvancar;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t3 || $[13] !== t6) {
    t7 = <div className="flex flex-wrap items-center justify-between gap-4 border-t border-solid border-neutral-200 px-6 py-6 md:px-20">{t3}{t6}</div>;
    $[12] = t3;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};